import { z } from "zod";

import { associationSchema } from "./association";
import { associationMemberSchema } from "./association-member";

export const associationWithMembersSchema = associationSchema.extend({
  members: z.array(associationMemberSchema),
});

export type AssociationWithMembers = z.infer<
  typeof associationWithMembersSchema
>;
